import React from "react";
import { useNavigate } from "react-router-dom";

const ChocolateScreen = () => {
  const navigate = useNavigate();
  return (
    <section id="screen-chocolate" className="screen">
      {/* Background */}
      <div className="chocolate-background">
        <div
          className="choco-particle"
          style={{ "--x": "10%", "--delay": "0s" }}
        >
          🍫
        </div>
        <div
          className="choco-particle"
          style={{ "--x": "25%", "--delay": "0.5s" }}
        >
          🍬
        </div>
        <div
          className="choco-particle"
          style={{ "--x": "40%", "--delay": "1s" }}
        >
          🍭
        </div>
        <div
          className="choco-particle"
          style={{ "--x": "55%", "--delay": "1.5s" }}
        >
          🧁
        </div>
        <div
          className="choco-particle"
          style={{ "--x": "70%", "--delay": "2s" }}
        >
          🍪
        </div>
        <div
          className="choco-particle"
          style={{ "--x": "85%", "--delay": "0.3s" }}
        >
          🍫
        </div>
      </div>

      <div className="chocolate-content">
        <h1 className="chocolate-title">Sweet Delights For My Sweetheart 🍫</h1>

        <div className="chocolate-display">
          {/* Chocolate Box */}
          <div className="chocolate-box-container">
            <div className="chocolate-box">
              <div className="box-lid">
                <div className="lid-pattern" />
                <div className="box-bow">
                  <div className="bow-left" />
                  <div className="bow-right" />
                  <div className="bow-center">💝</div>
                </div>
              </div>

              <div className="box-base">
                <div className="chocolates-grid">
                  <div className="choco-item" data-type="dairymilk">
                    <div className="choco-wrapper purple">
                      <span className="choco-label">🥛</span>
                    </div>
                    <span className="choco-name">Dairy Milk</span>
                  </div>

                  <div className="choco-item" data-type="kitkat">
                    <div className="choco-wrapper red">
                      <span className="choco-label">🍫</span>
                    </div>
                    <span className="choco-name">KitKat</span>
                  </div>

                  <div className="choco-item" data-type="fivestar">
                    <div className="choco-wrapper gold">
                      <span className="choco-label">⭐</span>
                    </div>
                    <span className="choco-name">Five Star</span>
                  </div>

                  <div className="choco-item" data-type="ferrero">
                    <div className="choco-wrapper golden">
                      <span className="choco-label">🌰</span>
                    </div>
                    <span className="choco-name">Ferrero</span>
                  </div>

                  <div className="choco-item" data-type="snickers">
                    <div className="choco-wrapper brown">
                      <span className="choco-label">🥜</span>
                    </div>
                    <span className="choco-name">Snickers</span>
                  </div>

                  <div className="choco-item" data-type="galaxy">
                    <div className="choco-wrapper pink">
                      <span className="choco-label">✨</span>
                    </div>
                    <span className="choco-name">Galaxy</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Floating chocolates */}
            <div className="floating-chocolates">
              <div className="float-choco" style={{ "--delay": "0s" }}>
                🍫
              </div>
              <div className="float-choco" style={{ "--delay": "0.5s" }}>
                🍬
              </div>
              <div className="float-choco" style={{ "--delay": "1s" }}>
                🍭
              </div>
              <div className="float-choco" style={{ "--delay": "1.5s" }}>
                🧁
              </div>
              <div className="float-choco" style={{ "--delay": "2s" }}>
                🍪
              </div>
            </div>
          </div>

          {/* Sweet Messages */}
          <div className="sweet-messages">
            <div className="sweet-card">
              <span className="sweet-icon">🍫</span>
              <p>"Sweet like chocolate, precious like you"</p>
            </div>

            <div className="sweet-card">
              <span className="sweet-icon">🍬</span>
              <p>"You make life sweeter every day"</p>
            </div>

            <div className="sweet-card">
              <span className="sweet-icon">💕</span>
              <p>"My favorite flavor is 'Us'"</p>
            </div>
          </div>
        </div>

        {/* Navigation */}
        <div className="nav-buttons">
          <button
            className="btn btn-back"
            data-back="letter"
            onClick={() => navigate(-1)}
          >
            ← Previous
          </button>
          <button
            className="btn btn-next"
            data-next="surprise"
            onClick={() => navigate("/letter")}
          >
            Next Gift →
          </button>
        </div>
      </div>
    </section>
  );
};

export default ChocolateScreen;
